import React from 'react';

export default class Footer extends React.Component {
  render() {
    return (

      <div className="footer">
        © {(new Date().getFullYear())} All Rights Reserved.
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.js